import { render, staticRenderFns } from "./detaille_vidange.vue?vue&type=template&id=baf8c1a8&scoped=true&"
import script from "./detaille_vidange.vue?vue&type=script&lang=js&"
export * from "./detaille_vidange.vue?vue&type=script&lang=js&"
import style0 from "./detaille_vidange.vue?vue&type=style&index=0&lang=css&"
import style1 from "./detaille_vidange.vue?vue&type=style&index=1&id=baf8c1a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf8c1a8",
  null
  
)

export default component.exports